<template>
  <div>
    <b-modal>
        
    </b-modal>
    <div class="painel-ronaldo">    
    </div>
      <div class="opcoess">
            <div :class="{atual:1 == atual}" @click="ClickAtual(1,'/revisorPisCofins/img/protecaoBranca.svg','Revisar Notas','revisar')">
                <img src="/revisorPisCofins/img/RevisarNotasBranco.svg" alt="" v-if="atual ==1">
                <img src="/revisorPisCofins/img/RevisarNotas.svg" alt="" v-else>
                <span>Revisar Notas</span>
            </div>
            <div :class="{atual:2 == atual}" @click="ClickAtual(2,'/revisorPisCofins/img/documentoBranco.svg','Lista de NCMs','ncms')">
                <img src="/revisorPisCofins/img/ListaNcmsBranco.svg" alt="" v-if="atual == 2">
                 <img src="/revisorPisCofins/img/ListaNcms.svg" alt="" v-else>
                <span>Lista de NCMs</span>
            </div>
            <div :class="{atual:3 == atual}" @click="ClickAtual(3,'/revisorPisCofins/img/brasil2Branco.svg','Minhas Consultas','consultas')">
                <img src="/revisorPisCofins/img/MinhasConsultasBranco.svg" alt="" v-if="atual == 3">
                <img src="/revisorPisCofins/img/MinhasConsultas.svg" alt="" v-else>
                <span>Minhas Consultas</span>
            </div>
          
      </div>      
      <div class="atualheader">
        <img :src="img" width="30px" height="30px"> {{txt}} 
      </div>
      <div style="padding:40px 20px;">
        <RevisarNotas v-if="$route.params.id == 1"/>
        <ListaNcms v-if="$route.params.id == 2" /> 
        <MinhasConsultas v-if="$route.params.id == 3" @receberAtual="atual = $event"/>      
       </div>
  </div>
</template>

<script>
import RevisarNotas from '../shared/RevisarNotas.vue'
import ListaNcms from '../shared/ListaNcms.vue'
import MinhasConsultas from '../shared/MinhasConsultas.vue'
export default {
    components:{
        RevisarNotas ,
        ListaNcms,
        MinhasConsultas,        
    },
    data(){
        return{
            atual:false,
            txt:'',
            img:''
        }
    },
    methods:{
        ClickAtual(ia,img,txt,params){
            this.$router.push({name:'op',params:{id:ia,isConsulta:params}})
            this.atual= ia
            this.img = img
            this.txt = txt        
        }
    },
    mounted(){
        
        let rota = this.$route.params.id
        if(rota ==1){
            this.txt = 'Revisar Notas'
            this.atual = 1
        }else if(rota ==2){
            this.txt = 'Lista de NCMs'
            this.atual = 2
        }else if(rota == 3){
            this.txt = 'Minhas Consultas'
            this.atual = 3
        }
    }
}
</script>

<style>
.painel-ronaldo{  
  background-image: url('/revisorPisCofins/img/banerP2.svg') ;  
  background-repeat: no-repeat;
  position: relative;
 background-size: 100%;
    height: 135px;
  width: 100%;
  max-height: 415px;
  display: flex;
  align-items: center;
  padding-bottom:5%;
  justify-content: center;

}
.atualheader{
     background: #AF3437 ;
     padding:17px 25px;
     color:#fff;
         display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
}
.atual{
    background: #AF3437 !important;
}
.atual span{
    color:#FFFFFF !important
}
.opcoess{
    display: flex;
    align-items: center;
   justify-content: center;
   margin-top:30px;
}
.opcoess div{
    background: #EDE4ED;
    color: #AF3437;
    font-weight: bold;
    padding: 8px 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #AF3437;
    border-bottom: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin-left: 10px;
    font-size: 15px;
}
.opcoess div img{
    width: 50px;
    height: 42px;
}
.opcoess div span{
    margin-left: 5px;
}
@media screen and (max-width: 600px) {
    .opcoess div img {
        width: 35px;
        height: 35px;
    }
    .opcoess div {
    background: #EDE4ED;
    color: #AF3437;
    font-weight: bold;
    padding: 6px 19px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
     border: none; 
    border-bottom: 0;
     border-top-left-radius: 0px; 
     border-top-right-radius: 0px; 
     margin-left: 0px;
    font-size: 16px;
    width: 100%;
    }
    .opcoess{
        flex-direction: column;
    }
}
</style>